import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-main-movimientos-personal',
  templateUrl: './main-movimientos-personal.component.html',
  styleUrls: ['./main-movimientos-personal.component.css']
})
export class MainMovimientosPersonalComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
